// libs
import { styled } from '@nykaa/ui-components';

export const MenuItemsContainer = styled.div`
  display: flex;
  margin-left: ${({ theme }) => theme.spacing.spacing240};
  height: 100%;
  width: 100%;
`;
